import React from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { routeForAccessContext, useAccess } from "../auth/AccessProvider";
import AccessRouteState from "../auth/AccessRouteState";
import CentralDashboardShell from "../components/CentralDashboardShell";

export default function AccessRoleSelectorPage() {
  const navigate = useNavigate();
  const { user, accessContext, platform, activeTenant, loading, signOutUser } = useAccess();
  if (loading) return <AccessRouteState />;
  if (!user) return <Navigate to="/login" replace />;
  if (!platform?.enabled || activeTenant?.tenantRole !== "tenant_admin") {
    return <Navigate to={routeForAccessContext(accessContext)} replace />;
  }
  const signOut = async () => { await signOutUser(); navigate("/login", { replace: true }); };
  return (
    <CentralDashboardShell user={accessContext?.user || user} organisation="AndUs central access" navItems={[{ id: "overview", label: "Choose workspace", icon: "systems" }]} activeSection="overview" onSectionChange={() => {}} onSignOut={signOut}>
      <section className="pa-role-selector"><p>Your AndUs workspace</p><h1>Choose where to continue.</h1><span>Your account has both Platform and Tenant Administrator access.</span><div><Link to="/platform-admin/dashboard"><strong>Platform administration</strong><small>Manage companies, allocation and administrator access.</small><b>›</b></Link><Link to="/tenant-admin/dashboard"><strong>{activeTenant.displayName || "Tenant administration"}</strong><small>Manage tenant users and open allocated systems.</small><b>›</b></Link></div></section>
    </CentralDashboardShell>
  );
}
